<template>
  <div>
    <Navbar activeDirectory="dati" activePage="reports"></Navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-4 offset-md-4">
          <div class="card">
            <div class="card-body">
              Genera il report del lotto 
              <select class="form-control" v-model="lotto">
                <option value="1">Lotto 1</option>
                <option value="2">Lotto 2</option>
              </select>
              <br>Per il giorno
              <input type="date" class="form-control"  v-model="date" />
              <br />
              <button class="btn btn-primary" @click="download()" :class="[{'disabled': printing}]">
                Report Giornaliero
                <i class="fa fa-download"></i>
                <br />
                <span class="badge badge-secondary">Lotto {{ lotto }} il {{ formatDate(date) }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar
  },

  data() {
    return {
      date: new Date().toISOString().split("T")[0],
      lotto: 1,
      printing: false,
    };
  },

  methods: {
    formatDate(dt) {
      if (dt){
        var _dt = dt.split('-')
        return `${_dt[2]}/${_dt[1]}/${_dt[0]}`
      } else {
        return ''
      }
      
    },

    download() {
      this.printing=true;
      this.axios.get(`report/${this.lotto}/${this.date}`,{responseType: 'blob'}).then(response=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `lotto_${this.lotto}_report_${this.date}.pdf`);
        document.body.appendChild(link);
        link.click();
        this.printing=false;
      })
    }
  }
};
</script>

<style>
</style>